import { Injectable } from '@angular/core';
import {
  PulseConfigurationKeys,
  PulseConfigurations,
  PULSE_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/pulse-rules';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import { TrackingService } from '@epicuro-next/platform/tracking';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs/operators';

import { gtmTrackActions } from '../actions';

@Injectable()
export class EcommerceTrackingEffects {
  constructor(
    private trackingService: TrackingService,
    private actions$: Actions,
    private store: Store,
  ) {}

  public trackEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(gtmTrackActions.gtmEcommerceTrackEvent),
        concatLatestFrom(() => [
          this.store.pipe(
            select(
              selectConfigurationValueFrom<
                PulseConfigurationKeys.GTMEcommerceEventsMap,
                PulseConfigurations
              >(
                PULSE_FEATURE_NAME,
                PulseConfigurationKeys.GTMEcommerceEventsMap,
                '',
              ),
            ),
            map((value: string) => {
              try {
                return JSON.parse(value);
              } catch {
                return {};
              }
            }),
          ),
          this.store.pipe(
            select(
              selectConfigurationValueFrom<
                PulseConfigurationKeys.GTMEcommerceEventsEnabled,
                PulseConfigurations
              >(
                PULSE_FEATURE_NAME,
                PulseConfigurationKeys.GTMEcommerceEventsEnabled,
                false,
              ),
            ),
          ),
        ]),
        filter(([, , enabled]) => {
          return !!enabled;
        }),
        tap(([{ value }, eventsMap]) => {
          const { event, ...params } = value;
          this.trackingService.ecommerceEventTrack({
            ...params,
            event: eventsMap[event as string] ?? event,
          });
        }),
      ),
    { dispatch: false },
  );
}
